export default __webpack_public_path__ + "static/media/pg-dropdown.999a7d57.webp";